import React, { useState } from 'react'
import BaseModal from '../BaseModal'
import ButtonPrimary from '../ui/ButtonPrimary'
import BaseCheckbox from '../BaseCheckbox'
import './index.css'

const VarianceListPreModal = (props) => {
  /** This state hook tracks whether the user has selected a bin-based or part-based counting methodology. **/
  const [currentMode, setCurrentMode] = useState('bin_centric')

  /** This handler triggers the parent selection logic and hardcodes zero users to bypass backend auto-assignment. **/
  const selectCountingMode = () => {
    // Automatically passing 0 to prevent backend auto-assignment
    props.onSelect(currentMode, 0)
  }

  /** This JSX block defines the selection interface, allowing users to toggle between the two available counting modes. **/
  const body = (
    <div className="info-modal variance-list-modal variance-list-modal--short">
      <h2 className="info-modal__title">Select counting mode</h2>
      <div className="variance-list-modal__team-members">
        <ul className="variance-list-modal__team-list">
          <li className="variance-list-modal__team-member">
            <BaseCheckbox
              checkboxId="bin_centric"
              isChecked={currentMode === 'bin_centric'}
              checkboxBody="Bin centric"
              onCheck={() => setCurrentMode('bin_centric')}
            />
          </li>
          <li className="variance-list-modal__team-member">
            <BaseCheckbox
              checkboxId="part_centric"
              isChecked={currentMode === 'part_centric'}
              checkboxBody="Part centric"
              onCheck={() => setCurrentMode('part_centric')}
            />
          </li>
        </ul>
      </div>
    </div>
  )

  /** This block defines the modal footer containing the primary action button to confirm the selected mode. **/
  const footer = (
    <div className="variance-list-modal__form-group variance-list-modal__controls variance-list-modal__footer">
      <ButtonPrimary name="Select" onClick={selectCountingMode} />
    </div>
  )

  /** This return statement wraps the constructed body and footer into a standardized base modal component. **/
  return (
    <BaseModal
      onClose={props.onClose}
      body={body}
      footer={footer}
    />
  )
}

export default VarianceListPreModal